
export default function delQGroup(way, delInd){
    this.dataArrayDelete([{way : way, index : delInd}]);
}